import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getRentSearchList } from '../searchThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'rentSearch';

export const rentSearchSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: builder => {
        handleRequestThunk({ builder, request: getRentSearchList });
    },
});

export const rentSearch = rentSearchSlice.reducer;
